import AdvantagesBackGroundImage from "../../assets/images/advantages_background.jpg";
import ValuesImage from "../../assets/images/advantages_background.jpg";

import "./MainPage.css";
import {FullscreenControl, Map, Placemark, RulerControl, YMaps, ZoomControl} from "@pbe/react-yandex-maps";
import {useNavigate} from "react-router-dom";
import QualityIcon from "../../assets/images/qualityIcon.png";
import ReliabilityIcon from "../../assets/images/reliabilityIcon.png";
import EcologyIcon from "../../assets/images/ecologyIcon.png";

import MelImage from "../../assets/images/mel.jpg";

const productionsData = [
        {
            key: '1',
            product: 'МТП-1',
            link: "MTP-1"
        },
        {
            key: '2',
            product: 'МТП-2',
            link: "MTP-2"
        },
        {
            key: '3',
            product: 'МДП-1',
            link: "MDP-1"
        },
        {
            key: '4',
            product: 'МДП-2',
            link: "MDP-2"
        },
        {
            key: '5',
            product: 'ММЖП',
            link: "MMGP"
        },
        {
            key: '6',
            product: 'Кормовой мел',
            link: "KormovoyMel"
        }
    ];


const MainPage = () => {

    const nav = useNavigate();

    return(
        <div className={"mp-container"}>
            {/*<div className={"mp-photos-block"}>*/}
            {/*    <div className={"mp-photos-container"}>*/}
            {/*        <div className="photos-row">*/}
            {/*            <div className="photo-circle">*/}
            {/*                <img src={FactoryImage2} alt="Описание фото 1"/>*/}
            {/*            </div>*/}
            {/*            <div className="photo-circle elevated">*/}
            {/*                <img src={LongViewImage2} alt="Описание фото 2"/>*/}
            {/*            </div>*/}
            {/*            <div className="photo-circle">*/}
            {/*                <img src={LongViewImage3} alt="Описание фото 3"/>*/}
            {/*            </div>*/}
            {/*        </div>*/}
            {/*    </div>*/}

            {/*    <div className={"mp-under-photo-container"}>*/}
            {/*        <p>*/}
            {/*            Качество мела, добытого на месторождении “Мирское”, признается специалистами как <br/>высочайшее.*/}
            {/*        </p>*/}
            {/*        <p>*/}
            {/*            Стабильное качество сырья обеспечивает постоянство высоких характеристик*/}
            {/*            производимой <br/> продукции.*/}
            {/*        </p>*/}
            {/*    </div>*/}
            {/*</div>*/}


            <div className={"mp-values-block"}>
                <div className={"mp-values-text"}>
                    <h4> Наши ценности </h4>
                    <div className={"mp-values-text-row"}>
                        <img src={QualityIcon}/>

                        <div className={"mp-values-text-row-text"}>
                            <h5> Качество </h5>
                            <p> Мы гарантируем высочайшее качесто нашей продукции </p>
                        </div>
                    </div>

                    <div className={"mp-values-text-row"}>
                        <img src={ReliabilityIcon}/>
                        <div className={"mp-values-text-row-text"}>
                            <h5> Надежность </h5>
                            <p> Стабильные поставки и строгое соблюдение сроков </p>
                        </div>
                    </div>

                    <div className={"mp-values-text-row"}>
                        <img src={EcologyIcon}/>
                        <div className={"mp-values-text-row-text"}>
                            <h5> Экологичность </h5>
                            <p> Работаем с заботой об окружающей среде </p>
                        </div>
                    </div>

                </div>

                <div className={"map-values-image"}>
                    <img src={ValuesImage}/>
                </div>
            </div>

            <div className={"mp-advantages-container"}>
                <img src={AdvantagesBackGroundImage} alt="Header Background" style={{width: "100%"}}/>
                <div className={"mp-advantages-container-centered"}>
                    <h1> Наши преимущества </h1>
                </div>
                <div className={"mp-advantages-container-main"}>
                    <div className={"mp-advantages-container-row"}>
                        <div className={"mp-advantages-container-card"}>
                            <h3>Крупное месторождение</h3>
                            <div className={"mp-advantages-container-card-text"}>
                                <p>
                                    Местонахождение “Мирское” является одним из крупнейших в Центральном Федеральном
                                    Округе. Карьер
                                    находится в непосредственной близости от предприятия
                                </p>
                            </div>
                        </div>
                        <div className={"mp-advantages-container-card"}>
                            <h3>Современное оборудование</h3>
                            <div className={"mp-advantages-container-card-text"}>
                                <p> Оборудовние и автоматика производственной линии поставлялась ведущими российскими и
                                    зарубежными компаниями </p>
                            </div>
                        </div>
                        <div className={"mp-advantages-container-card"}>
                            <h3>Высокое содержание кальция</h3>
                            <div className={"mp-advantages-container-card-text"}>
                                <p>
                                    Мы добываем мел с самым высоким содержанием природного кальция
                                </p>
                            </div>
                        </div>
                        <div className={"mp-advantages-container-card"}>
                            <h3>Контроль <br/> качества</h3>
                            <div className={"mp-advantages-container-card-text"}>
                                <p>
                                    Лаборатория предприятия оборудована всем необходимым для контроля качества
                                    производимой продукции. Мы производим мел по ТУ 08.11.30-001-88724763-2020
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className={"mp-productions-block"}>
                <h1> Наша продукция </h1>
                <div className={"mp-productions-container"}>
                    <div className={"mp-productions-container-row"}>
                        {
                            productionsData.map((item) => (
                                <div className="product-card" key={item.key}>
                                    <div className="product-image" onClick={() => nav("/" + item.link)}>
                                        <img src={MelImage}/>
                                    </div>
                                    <div className="product-info">
                                        <h3 className="product-name">{item.product}</h3>
                                    </div>
                                </div>
                            ))
                        }
                    </div>
                </div>
            </div>

            <div className="mp-map-container">
                <YMaps>
                    <Map
                        defaultState={{center: [52.453346, 33.090728], zoom: 10}}
                        width="100%"
                        height="100%"
                    >
                        <Placemark defaultGeometry={[52.453346, 33.090728]}/>
                        <FullscreenControl/>
                        <RulerControl options={{float: "right"}}/>
                        <ZoomControl options={{float: "right"}}/>
                    </Map>
                </YMaps>
            </div>
        </div>
    )
}

export default MainPage;